module.exports = __webpack_public_path__ + "static/media/RecomendaAnoNovo.077c5933.jpg";